//@ts
var GRID_INSTANCES = {};

var register = function register(gridId, gridInstance) {
  GRID_INSTANCES[gridId] = gridInstance;
};

var unregister = function unregister(gridId) {
  delete GRID_INSTANCES[gridId];
};
/**
 *
 * @param {import("data/types").DataGridWhereClause} [where]
 */


var selectGrids = function selectGrids(where) {
  return Object.keys(GRID_INSTANCES).filter(function (gridId) {
    if (!where) return true;
    if (where.id) return gridId === where.id;
    var grid = GRID_INSTANCES[gridId];
    if (where.dataType) return grid.props.dataType === where.dataType;
    return false;
  }).map(function (gridId) {
    return GRID_INSTANCES[gridId];
  });
};
/**
 *
 * @param {import("data/types").DataGridWhereClause} [where] Filter all data grids rendered in the system
 * @param {import("data/types").DataGridRefreshOptions} options Argument to pass along to grid refresh action.
 */


var refresh = function refresh(where, options) {
  return Promise.all(selectGrids(where).map(function (grid) {
    return grid.refresh(options);
  }));
};

var API = {
  all: GRID_INSTANCES,
  register: register,
  unregister: unregister,
  refresh: refresh
};
export default API;